<template>
  <gj-modal
      :visible.sync="modalVisible"
      :loading="modalLoading"
      notFooterPadding
  >
    <template #header>发货单详情</template>
    <template #content>
      <app-shipment-bill-header-info
          :header-info-data="headerInfoData"
          :item="item" ref="headerInfo"></app-shipment-bill-header-info>
      <el-tabs :value="tabModel">
        <el-tab-pane name="productDetail" label="产品明细">
          <app-shipment-bill-product-detail
              :item="item"
              :product-items="productItems"></app-shipment-bill-product-detail>
        </el-tab-pane>
        <el-tab-pane name="shareDetail" label="分摊明细">
          <app-shipment-bill-share-detail
              :logistics-fee-list="logisticsFeeList"
          ></app-shipment-bill-share-detail>
        </el-tab-pane>
        <el-tab-pane name="log" label="操作日志">
          <app-shipment-bill-log :id="item.id"></app-shipment-bill-log>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="openShipmentFee" v-if="$permission('shipNote:logisticsFee')" type="primary">录入物流费用</gj-button>
      <gj-button @click="markCompleted" type="primary" v-if="$permission('shipNote:finish') && item.status === shipmentBillEnum.DELIVERYING">标记完成</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import AppShipmentBillLogisticsFee from '../../../common/logistics/shipment-bill/shipment-bill-logistics-fee';
  import AppShipmentBillHeaderInfo from "../../../common/logistics/shipment-bill/shipment-bill-header-info";
  import AppShipmentBillProductDetail from "../../../common/logistics/shipment-bill/shipment-bill-product-detail";
  import {shipmentBillEnum} from "../enum";
  import AppShipmentBillShareDetail from "./shipment-bill-share-detail";
  import AppShipmentBillLog from "./shipment-bill-log";
  import {getShipNoteDetail, shipNoteFinish} from "../../../../../api/logistics";

  export default {
    name: "app-shipment-bill-detail",
    components: {AppShipmentBillLog, AppShipmentBillShareDetail, AppShipmentBillProductDetail, AppShipmentBillHeaderInfo},
    mixins: [modalMixIn],
    props: {
      item: null,
    },
    created() {
      this.init();
    },
    data() {
      return {
        tabModel: 'productDetail',
        headerInfoData: null,
        productItems: null,
        logisticsFeeList: null,
        shipmentBillEnum: shipmentBillEnum,
        modalLoading: false
      }
    },
    methods: {
      init() {
        this.modalLoading = true
        getShipNoteDetail(this.item.id)
          .then((data) => {
            this.productItems = data.productItemList;
            this.logisticsFeeList = data.logisticsFeeList;
            this.headerInfoData = data;
          }).complete(() => this.modalLoading = false)
      },
      openShipmentFee() {
        this.$gjCreate(AppShipmentBillLogisticsFee, {
          props: {
            // id: this.item.id,
            code: this.item.code,
            productItems: this.productItems,
          },
          on: {
            inputSuccess: () => {
              this.init();
            },
          }
        })
      },
      markCompleted() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `标记完成？<br/>该发货单标记后将不再更新收货量，状态更新为“已完成”！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              shipNoteFinish(this.item.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('after');
                    this.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .generate-shipment-footer {
    padding-right: 40px;
    display: flex;
    font-weight: bold;
  }
  .not-form-item-mgb {
    margin-bottom: 0;
  }
  /deep/ .el-tabs__item{
    padding: 0 16px;
  }
</style>
